import React from "react";
import CycleOrderBox from "./CycleOrderBox";
import { isEmpty } from "lodash";
import { Box, Alert } from "@curves/ui-base";

const CycleOrderList = ({ orders, dialogRef, refresh }) => {
	return (
		<React.Fragment>
			{!isEmpty(orders) ? (
				<>
					<Box component="ul" className="main-orders">
						{orders.map(item => {
							return (
								<Box component="li" key={item?.cycleOrderID} className="order-item">
									<CycleOrderBox className={"main-order"} cycleOrderData={item} dialogRef={dialogRef} refresh={refresh} />
								</Box>
							);
						})}
					</Box>
				</>
			) : (
				<Alert color="info" severity="info" variant="filled">
					尚無資料
				</Alert>
			)}
		</React.Fragment>
	);
};

export default CycleOrderList;
